import { render } from "./error.vue?vue&type=template&id=27b43241&scoped=true"
import script from "./error.vue?vue&type=script&lang=ts"
export * from "./error.vue?vue&type=script&lang=ts"

import "./error.vue?vue&type=style&index=0&id=27b43241&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-27b43241"

export default script